import { useCallback, useRef, useState } from "react";
import { URLS } from "../constans";
import { isSupportChatAvailable, openSupport } from "../helpers/helpers";

/**
 * Opens the sales conversation, preferring the in-app Intercom messenger and
 * falling back to emailing support.
 *
 * `isExternalChatOpen` is exposed so modals can release focus traps while the
 * Intercom widget is showing.
 */
export const useContactSales = () => {
  const [isExternalChatOpen, setIsExternalChatOpen] = useState(false);
  const hasRegisteredIntercomOnHide = useRef(false);

  const contactSales = useCallback(() => {
    const intercom = window.Intercom;

    if (isSupportChatAvailable() && typeof intercom === "function") {
      try {
        if (!hasRegisteredIntercomOnHide.current) {
          intercom("onHide", () => {
            setIsExternalChatOpen(false);
          });
          hasRegisteredIntercomOnHide.current = true;
        }
        setIsExternalChatOpen(true);
        openSupport("");
        return;
      } catch (error) {
        setIsExternalChatOpen(false);
        // Fall through to the email fallback if Intercom invocation fails.
      }
    }

    window.location.assign(URLS.contactSales);
  }, []);

  return { contactSales, isExternalChatOpen, setIsExternalChatOpen };
};
